// Contact_Page.jsx
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Contact.css';

const RTL_LANGUAGES = ['ar', 'fa', 'he', 'ur'];

const ContactPage = () => {
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    subject: '',
    country: '',
    message: ''
  });
  const [statusMessageKey, setStatusMessageKey] = useState('');

  const currentLanguage = i18n.resolvedLanguage || i18n.language || 'en';
  const languageCode = currentLanguage.split('-')[0].toLowerCase();
  const isRTL = RTL_LANGUAGES.includes(languageCode);
  const direction = isRTL ? 'rtl' : 'ltr';

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((previousFormData) => ({
      ...previousFormData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessageKey('');

    try {
      // Replace with the actual API call to your backend.
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setStatusMessageKey(
          'Your message has been sent successfully. We will respond as soon as possible.'
        );
        setFormData({
          firstName: '',
          lastName: '',
          subject: '',
          country: '',
          message: ''
        });
      } else {
        setStatusMessageKey(
          'There was an error sending your message. Please try again later.'
        );
      }
    } catch (error) {
      setStatusMessageKey(
        'Network error. Please check your connection and try again.'
      );
    }
  };

  return (
    <div
      className={`contact-container ${isRTL ? 'contact-rtl' : 'contact-ltr'}`}
      dir={direction}
    >
      <div className="contact-form">
        <h2>{t('Contact Us')}</h2>
        <p className="contact-description">
          {t('We would love to hear from you. Please fill out the form below.')}
        </p>

        <form onSubmit={handleSubmit} aria-label={t('Contact Us')}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstName">{t('First Name')}</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder={t('Enter your first name')}
                autoComplete="given-name"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="lastName">{t('Last Name')}</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder={t('Enter your last name')}
                autoComplete="family-name"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="subject">{t('Subject')}</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder={t('Enter subject')}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="country">{t('Country')}</label>
            <input
              type="text"
              id="country"
              name="country"
              value={formData.country}
              onChange={handleChange}
              placeholder={t('Enter your country')}
              autoComplete="country-name"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">{t('Message')}</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder={t('Enter your message')}
              required
              rows="5"
            />
          </div>

          <button
            type="submit"
            className="contact-button"
            aria-label={t('Send Message')}
          >
            {t('Send Message')}
          </button>
        </form>

        {statusMessageKey && (
          <p className="contact-message" role="status" aria-live="polite">
            {t(statusMessageKey)}
          </p>
        )}
      </div>
    </div>
  );
};

export default ContactPage;
